import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const resendEmailVerification = () => {
  const url = `${apiConfiguration.apiUrl}/riders/resend-email-verification`;
  return axios.post(url);
};
